module.exports = __webpack_public_path__ + "images/for-business-block.png";